<mat-button-toggle-group [formControl]="control" [name]="control.name">
	<mat-button-toggle *ngFor="let option of options" [value]="option.id">
		<div class="toggle">{{ option.label }}</div>
	</mat-button-toggle>
</mat-button-toggle-group>
